require('./bootstrap');
require('bootstrap-material-design');

$(function(){

    var $wWidth = $(window).width(),
        $wHeight = $(window).height(),
        $wHRatio = $wHeight/100;

    jQuery.event.special.touchstart = {
        setup: function( _, ns, handle ){
            if ( ns.includes("noPreventDefault") ) {
                this.addEventListener("touchstart", handle, { passive: false });
            } else {
                this.addEventListener("touchstart", handle, { passive: true });
            }
        }
    };

    $.material.init();

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    // Login on it's slug
    $(document)
        .on('submit', '#app-login-form', function (e) {
            e.preventDefault();

            $('.form-group').removeClass('has-error');

            if( $('input[name="slug"]').val().length <= 0 ){
                $('input[name="slug"]').parent('div').parent('div.form-group').addClass('has-error');
                return false;
            }

            if( $('input[name="username"]').val().length <= 0 ){
                $('input[name="username"]').parent('div.form-group').addClass('has-error');
                return false;
            }

            if( $('input[name="password"]').val().length <= 0 ){
                $('input[name="password"]').parent('div.form-group').addClass('has-error');
                return false;
            }


            $.ajax({
                url: $('#app-login-form').attr('action'),
                type: 'POST',
                data: $('#app-login-form').serialize(),
                dataType: 'json',
                success: function (r) {
                    if(r.success == true){

                        $('#alert').html('&nbsp;');
                        $('#alert').hide();

                        document.location.href = r.url;
                    }else{

                        $('#alert').html(r.msg);
                        $('#alert').show();

                    }
                },
                error: function (error) {
                }
            });

        });

    require('./rotate_your_table.js');

});
